<template>
  <div class="air__utils__scrollTable mb-4">
    <a-table
      :rowKey="record => record.id"
      :columns="columns"
      :dataSource="data"
      :pagination="false"
      :scroll="{ x: 'max-content' }"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="progress" slot-scope="progress">
        <a-progress :percent="progress" :strokeColor="getProgressColor(progress)" size="small" :status="progress === 100 ? 'success' : 'active'" :format="() => `${progress}%`"/>
      </template>

      <template slot="status_breakdown" slot-scope="text, record">
        <div v-if="record.status_breakdown" class="d-flex flex-wrap justify-content-center" style="gap: 4px;">
          <a-tag color="green">Done: {{ record.status_breakdown.completed || 0 }}</a-tag>
          <a-tag color="blue">In Prog: {{ record.status_breakdown.in_progress || 0 }}</a-tag>
          <a-tag color="orange">Start: {{ record.status_breakdown.started || 0 }}</a-tag>
          <a-tag color="#595959" style="color: #fff;">Pending: {{ record.status_breakdown.not_started || 0 }}</a-tag>
        </div>
        <span v-else class="text-muted">-</span>
      </template>

      <template slot="topicsCompleted" slot-scope="topics_completed">
        <span class="font-weight-bold">{{ topics_completed }}</span>
      </template>

      <template slot="sectionsLagging" slot-scope="sectionsLagging">
        <a-tooltip title="Sections lagging behind overall class completion rate">
          <span :class="{'text-danger font-weight-bold': isLagging(sectionsLagging)}">
            {{ sectionsLagging }}
            <i v-if="isLagging(sectionsLagging)" class="fe fe-alert-circle ml-1" />
          </span>
        </a-tooltip>
      </template>

      <template slot="action" slot-scope="text, record">
        <a-tooltip placement="top" title="View Detailed Report">
          <a-button type="primary" size="medium" @click="$emit('viewDetails', record)">
            View Details
          </a-button>
        </a-tooltip>
      </template>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    title: 'Lesson Plan Name',
    dataIndex: 'lesson_plan_name',
    key: 'lesson_plan_name',
    width: 220,
    sorter: true,
    className: 'text-left',
  },
  {
    title: 'Class',
    dataIndex: 'class',
    key: 'class',
    width: 90,
    sorter: true,
    className: 'text-center',
  },
  {
    title: 'Subject',
    dataIndex: 'subject',
    key: 'subject',
    width: 140,
    sorter: true,
    className: 'text-center',
  },
  {
    title: 'Progress (Overall)',
    dataIndex: 'progress',
    key: 'progress',
    width: 160,
    scopedSlots: { customRender: 'progress' },
    sorter: true,
    className: 'text-center',
  },
  {
    title: 'Status Breakdown',
    dataIndex: 'status_breakdown',
    key: 'status_breakdown',
    width: 260,
    scopedSlots: { customRender: 'status_breakdown' },
    className: 'text-center',
  },
  {
    title: 'Topics Completed',
    dataIndex: 'topics_completed',
    key: 'topics_completed',
    width: 130,
    scopedSlots: { customRender: 'topicsCompleted' },
    className: 'text-center',
  },
  {
    title: 'Sections Lagging',
    dataIndex: 'sections_lagging',
    key: 'sections_lagging',
    width: 140,
    scopedSlots: { customRender: 'sectionsLagging' },
    className: 'text-center',
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    key: 'action',
    width: 120,
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
    className: 'text-center',
  },
]

export default {
  name: 'LessonPlanOverviewTable',
  props: {
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns,
    }
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      const sortColumn = sorter.field || null
      const sorterOrder = sorter.order || null
      this.$emit('updateTable', [sortColumn, sorterOrder, filters])
    },

    getProgressColor(progress) {
      if (progress < 30) return '#ff4d4f' // Antd Red (error)
      if (progress < 70) return '#faad14' // Antd Orange (warning)
      return '#52c41a' // Antd Green (success)
    },

    // Checks if the 'Sections Lagging' count (X) is greater than 0
    isLagging(sectionsLagging) {
      if (!sectionsLagging || typeof sectionsLagging !== 'string') return false
      // Extract the first number (X in X/Y)
      const count = parseInt(sectionsLagging.split('/')[0])
      return count > 0
    },
  },
}
</script>

<style scoped>
/* Scoped styles for the table if needed */
.text-danger {
    color: #ff4d4f;
}
</style>
